/**
 * Map content type to the correct API endpoint.
 * @param {string} contentType - type of content e.g. 'episode', 'shortform'
 */

export default function getApiPath(contentType) {
  return contentType === 'episode'
    ? 'episodes'
    : contentType
}
